import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Family Size
      {record ? `: ${record.name}` : ''}
    </span>
  );
};
